import { Types } from "@grandvisionhq/auth";
import { ShippingObjectTypes } from "../../../../state.js";
import { seedShippingForm } from "./seed-shipping-form.js";
const mappingCartForms = {
  [ShippingObjectTypes.ContactDetails]: "customer"
};
const mappingMyAccountData = {
  [ShippingObjectTypes.ContactDetails]: Types.FormName.personalDetails
};
const formIsTouched = (formDataFields) => {
  for (const field of Object.values(formDataFields || {})) {
    if (field?.isTouched) return true;
  }
  return false;
};
const mapShippingFormsUpdate = ({ cartData, userData, fields }, shippingDetails) => {
  const result = {};
  for (const key in ShippingObjectTypes) {
    const formName = ShippingObjectTypes[key];
    if (formIsTouched(shippingDetails?.[formName]?.formData)) continue;
    const userDataResult = userData.status === "success" ? userData.result : void 0;
    const formFields = fields?.[formName];
    const cartDataForm = cartData?.[mappingCartForms[formName] || formName];
    const myAccountData = userDataResult?.[mappingMyAccountData[formName] || formName];
    const inputForm = cartDataForm || myAccountData;
    if (!inputForm || !formFields) continue;
    let formValues = inputForm;
    if (inputForm && formName === ShippingObjectTypes.BillingAddress && "countryCode" in inputForm) {
      const { countryCode, ...rest } = inputForm;
      formValues = {
        ...rest,
        country: countryCode
      };
    } else if (formName === "contactDetails" && !formValues.email && userDataResult?.email) {
      formValues = {
        ...inputForm,
        email: userDataResult.email
      };
    }
    if (formName === "contactDetails" && userDataResult?.personalDetails?.ssn) {
      formValues = {
        ...formValues,
        customerVatId: userDataResult?.personalDetails?.ssn
      };
    }
    const shippingForm = seedShippingForm(formFields, formValues, shippingDetails?.[formName]);
    if (shippingForm) {
      result[formName] = shippingForm;
    }
  }
  return result;
};
export {
  mapShippingFormsUpdate
};
//# sourceMappingURL=map-shipping-forms-update.js.map
